import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDocuments } from 'store/documents/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

// TODO: extract document related data from system to a separate object
export const getDocumentTypes = createSelector(getSystem, ({ documentTypes }) => documentTypes);

const getDocumentTypesValues = createSelector(getDocumentTypes, documentTypes =>
  Object.values(documentTypes),
);

export const selectDocumentTypesOptions = createSelector(getDocumentTypesValues, documentTypes =>
  documentTypes.map(({ documentTypeName, documentTypeId }) => ({
    name: documentTypeName,
    value: documentTypeId,
  })),
);

export const getFilteredDocumentTypes = createSelector(
  getDebouncedSearchValue,
  getDocumentTypesValues,
  searchItems(documentType => [documentType.documentTypeName]),
);

export const getDocumentTypeById = memoizeOne(id =>
  createSelector(getDocumentTypes, docTypes => docTypes[id]),
);

export const selectDocumentTypeNameById = memoizeOne(id =>
  createSelector(getDocumentTypes, docTypes => docTypes[id]?.documentTypeName),
);

export const selectDocumentTypeNameByDocumentId = memoizeOne(documentId =>
  createSelector([getDocuments, getDocumentTypes], (documents, docTypes) => {
    const { documentTypeId } = documents[documentId] || {};

    return docTypes[documentTypeId]?.documentTypeName;
  }),
);

export const selectActiveDocumentTypesOptions = createSelector(
  getDocumentTypesValues,
  documentTypes =>
    documentTypes
      .filter(
        ({ isExcludedFromDataExtraction, isInactive }) =>
          !isExcludedFromDataExtraction && !isInactive,
      )
      .map(({ documentTypeName, documentTypeId }) => ({
        name: documentTypeName,
        value: documentTypeId,
      })),
);

export const selectExcludedDocumentTypes = createSelector(getDocumentTypes, documentTypes =>
  _.pickBy(
    documentTypes,
    ({ isExcludedFromDataExtraction, isInactive }) => isExcludedFromDataExtraction && !isInactive,
  ),
);

export const selectActiveDocumentTypes = createSelector(getDocumentTypes, documentTypes =>
  _.pickBy(documentTypes, ({ isInactive }) => !isInactive),
);

export const selectIsDocumentTypeWorksheetEnabled = memoizeOne(documentTypeId =>
  createSelector(getDocumentTypes, docTypes => !!docTypes[documentTypeId]?.isWorksheetEnabled),
);
